import { Helmet } from 'react-helmet-async';
import paypal from './img/paypal.png';
import privatBank from './img/privat_bank.png';
import boosty from './img/boosty.png';

function Pricing() {
  return (
    <>
      <Helmet>
        <title>Стоимость | ИИ-Менеджер для Продаж 24/7</title>
        <meta name="description" content="Узнайте стоимость ИИ-консультанта: бесплатная разработка, обслуживание 95 евро/месяц, OpenAI API от 30 евро/месяц. Автоматизируйте продажи выгодно!" />
        <meta name="keywords" content="стоимость ИИ-консультанта, автоматизация продаж, цена, CRM интеграция, OpenAI API" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="UTF-8" />
        <meta name="author" content="ИИ Консультант" />
        <meta property="og:title" content="Стоимость | ИИ-Менеджер для Продаж 24/7" />
        <meta property="og:description" content="Бесплатная разработка ИИ-консультанта, обслуживание 95 евро/месяц, OpenAI API от 30 евро/месяц. Узнайте, как сэкономить!" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ailink.services/pricing" />
        <meta property="og:image" content="/img/name.png" />     
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Стоимость | ИИ-Менеджер для Продаж 24/7" />
        <meta name="twitter:description" content="Стоимость ИИ-консультанта: бесплатная разработка, 95 евро/месяц за обслуживание, API от 30 евро/месяц." />
        <meta name="twitter:image" content="/images/ai-consultant.jpg" />
        <link rel="canonical" href="https://ailink.services/pricing" />
      </Helmet>

      <section className="section">
        <div className="container">
          <h2>Стоимость подписки</h2>
          <div className="pricing">
            <div className="pricing-card">
              <h3>Разработка и настройка</h3>
              <p className="price free">Бесплатно</p>
              <p>Разработка уникального ИИ-менеджера, подключение базы данных, аккаунтов, CRM, Rest API.</p>
            </div>
            <div className="pricing-card">
              <h3>Обслуживание и настройка</h3>
              <p className="price">95 евро/месяц</p>
              <p>Ежемесячная плата за обслуживание, техническую поддержку и обновление.</p>
            </div>
            <div className="pricing-card">
              <h3>OpenAI API</h3>
              <p className="price">от 30 евро/месяц</p>
              <p>Зависит от количества токенов. В среднем — 50 евро/месяц.</p>
            </div>
          </div>
        </div>
        

               <div className="pay-methods">
          <div className="channel-card">
            <img src={paypal} alt="Paypal" width="64" height="64" />
          </div>
          <div className="channel-card">
            <img src={privatBank} alt="PrivatBank" width="64" height="64" />
          </div>
          <div className="channel-card">
            <img src={boosty} alt="Boosty" width="64" height="64" />
          </div>

        </div>
      </section>
    </>
  );
}

export default Pricing;